import * as apiPostReport from 'api/report/PostReportV1';
import { FileModel } from 'apiAuto/report/schemas/FileModel';

export * as Report from 'containers/desktop/Reports/types/Report';

export type Type = {
	id: string;
	uploadedAt: Date;
	status: "done" | "processing" | "failed" | "error" | "source" | "validate";
	username: string;
	dateStart: string;
	dateEnd: string;
	groupName: string;
	isSelected: boolean;
};

export function create(): Type {
	return {
		id: '',
		uploadedAt: new Date(),
		status: 'processing',
		username: '',
		dateStart: '',
		dateEnd: '',
		groupName: '',
		isSelected: false,
	};
}

export type UploadError = {
	status: number;
	detail?: {
		message?: string;
		filename?: string;
		error_type?: number; // 1 = MISSING_COLUMNS, 2 = INVALID_FIELDS, 3 = INVALID_UNIT
		// Error Type 1: MISSING_COLUMNS
		missing_columns?: string[];
		required_columns?: string[];
		// Error Type 2: INVALID_FIELDS
		errors?: Array<{
			row: number;
			column: string;
			value: string;
			issue: string;
			expected?: string;
		}>;
		total_rows?: number;
		// Error Type 3: INVALID_UNIT
		invalid_units?: string[];
		allowed_units?: string[];
		// Common
		hint?: string;
	};
};

export type UploadResult = {
	success: boolean;
	error?: UploadError;
};

export async function postFileToApi(
	file: File,
	email: string,
	dateStart: string,
	dateEnd: string
): Promise<UploadResult> {
	const result = await apiPostReport.callApiWithError({
		body: {
			uploader: email,
			dateStart: dateStart,
			dateEnd: dateEnd,
		},
		file: file,
	});

	if (result.success && result.data) {
		return { success: true };
	}

	const error = result.error;
	const errorResponse = error?.response;

	if (errorResponse?.status === 422 && errorResponse?.data?.detail) {
		return {
			success: false,
			error: {
				status: 422,
				detail: errorResponse.data.detail,
			},
		};
	}

	return {
		success: false,
		error: {
			status: errorResponse?.status || 500,
			detail: {
				message: errorResponse?.data?.message || error?.message || 'Upload failed',
			},
		},
	};
}

export function mapFromApi(input: FileModel): Type {
	return {
		id: input.fileId,
		uploadedAt: new Date(input.uploadedAt),
		status: input.status,
		username: input.username,
		dateStart: input.dateStart,
		dateEnd: input.dateEnd,
		groupName: input.groupName,
		isSelected: false,
	};
}

export function setSelectedToFalse(report: Type): Type {
	return {
		...report,
		isSelected: false,
	};
}

export function setSelectedToTrue(report: Type): Type {
	return {
		...report,
		isSelected: true,
	};
}

export function toggleSelect(report: Type): Type {
	if (report.isSelected) {
		return setSelectedToFalse(report);
	}
	return setSelectedToTrue(report);
}
